import React from 'react';
import styled from 'styled-components';

import {
    WhiteMan as WhiteSource,
    RedMan as RedSource,
    GreenMan as GreenSource,
} from '../../Constants/assets';

const TableDefinitions = styled.div`
    width: 100%;
    margin: 5px auto;
    height: 80%;
    display: flex;
    flex-direction: column;
`;
const TableData = styled.div`
    line-height: 21.8px;
    font-size: 16px;
    width: 90%;
`;

export default function PopUpLine({ Cost, blueAmount, greenAmount, redAmount, gate, gateNumber }) {
    if (gateNumber == gate) {
        return (
            <TableDefinitions>
                {blueAmount !== 0 && <TableData>{blueAmount} Regular Resources</TableData>}
                {redAmount !== 0 && <TableData>{redAmount} Senior Resources</TableData>}
                {greenAmount !== 0 && <TableData>{greenAmount} Executive Resources</TableData>}
                {Cost !== 0 && <TableData>${Cost}</TableData>}
            </TableDefinitions>
        );
    }
    return null;
}
